<div class="sla-management-container" *ngIf="!isLabelsLoading">
	<div class="header-wrap">
		<span class="tab" [ngClass]="{ selected: selectedTab === 'management' }" (click)="selectedTab = 'management'; clearInputs(false)">{{
			labels.lbl_geral_pesquisar
		}}</span>
		<span class="tab" [ngClass]="{ selected: selectedTab === 'create' }" (click)="selectedTab = 'create'; clearInputs(true)">{{
			labels.lbl_geral_gerenciamento_sla
		}}</span>
	</div>

	<div class="body-wrap" *ngIf="selectedTab === 'management'">
		<div class="container">
			<span class="title">{{ labels.lbl_geral_pesquisar }}</span>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_chamado_tipo_servico }} *</span>
				<select [(ngModel)]="filter.serviceType" id="serviceType" name="serviceType">
					<option *ngFor="let option of serviceTypeFilterOptions" [value]="option.value">{{ option.label }}</option>
				</select>
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_grupo }}</span>
				<select [(ngModel)]="filter.solutionArea" name="solutionArea">
					<option value="" [selected]="!filter.solutionArea">{{ labels.lbl_geral_selecione }}</option>
					<option *ngFor="let solutionArea of solutionAreaFilterOptions" [value]="solutionArea.solutionArea">
						{{ solutionArea.solutionArea }}
					</option>
				</select>
			</div>

			<div class="button-container">
				<div class="button" (click)="getAllSla()">{{ labels.lbl_geral_pesquisar }}</div>
			</div>
		</div>

		<cpi-msp-table
			*ngIf="isSlaLoading"
			[header]="searchHeader"
			[body]="slaDataSearch"
			[height]="'35dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			[insideSort]="true"
			(getSelectedItem)="openUpdatedForm($event[0])">
		</cpi-msp-table>
	</div>

	<div class="body-wrap" *ngIf="selectedTab === 'create'">
		<div>
			<form>
				<pcp-request-classification
					(getClassification)="setClassification($event)"
					[initialIdCategory]="slaData[0].category"
					[initialIdScope]="slaData[0].scope"
					[initialIdTopic]="slaData[0].topic"
					[initialIdSeverity]="slaData[0].severity"
					[initialIdServicetype]="slaData[0].serviceTypeId"
					[initialIdSolutionArea]="slaData[0].solutionAreaId"
					[isEditingClassification]="true"
					[initOn]="'changeType'"
					[hideServiceType]="'1, 3, 4, 5'"
					[requiredField]="'serviceType'"
					*ngIf="showRequestClassification">
				</pcp-request-classification>

				<!-- <div class="dotted-input-container" *ngIf="!showRequestClassification">
          <span>{{ labels.lbl_chamado_tipo_servico }} *</span>
          <select [(ngModel)]="slaData[0].serviceTypeId" id="serviceTypeId" name="serviceTypeId" (change)="onServiceTypeChange($event.target.value); loadTemplate($event.target.value)">
            <option *ngFor="let option of serviceTypeOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </div> -->

				<cpi-dot-bounce-loading-effect
					class="mt-2 ml-2"
					*ngIf="isTemplateLoading"
					[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
				<div class="dotted-input-container" *ngIf="!isTemplateLoading && slaData[0].serviceTypeId">
					<span>Template</span>
					<select [(ngModel)]="slaData[0].tasksTemplate" name="template">
						<option value="" [selected]="!slaData[0].tasksTemplate">{{ labels.lbl_geral_selecione }}</option>
						<option *ngFor="let template of templatesOptions" [value]="template.id">{{ template.template }}</option>
					</select>
				</div>

				<!-- <div class="dotted-input-container" *ngIf="slaData[0].serviceTypeId == '2'">
          <span>{{ labels.lbl_geral_grupo }} *</span>
          <select [(ngModel)]="slaData[0].solutionAreaId" name="solutionArea">
            <option value="" [selected]="!slaData[0].solutionAreaId">{{ labels.lbl_geral_selecione }}</option>
            <option *ngFor="let solutionArea of solutionAreaFilterOptions" [value]="solutionArea.id">{{ solutionArea.solutionArea }}</option>
          </select>
        </div> -->

				<div class="dotted-input-container" *ngIf="slaData[0].serviceTypeId == '2'">
					<span>{{ labels.lbl_geral_severidade }} *</span>
					<select [(ngModel)]="slaData[0].severity" name="severityForTemplate">
						<option value="" [selected]="!slaData[0].severity">{{ labels.lbl_geral_selecione }}</option>
						<option *ngFor="let severity of severitiesOptions" [value]="severity.severity">{{ severity.severity }}</option>
					</select>
				</div>

				<div class="dotted-input-container" *ngIf="slaData[0].serviceTypeId == '2'">
					<span>{{ labels.lbl_chamado_severidade_alta }} *</span>
					<cpi-checkbox
						[value]="slaData[0].highSeverity ?? 0"
						(oValue)="slaData[0].highSeverity = $event"
						[innerText]="slaData[0].highSeverity == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>

				<div class="dotted-input-container" *ngIf="slaData[0].serviceTypeId == '2'">
					<span>{{ labels.lbl_geral_usuario_generico }}</span>
					<cpi-checkbox
						[value]="slaData[0].genericEnduser ?? 0"
						(oValue)="slaData[0].genericEnduser = $event"
						[innerText]="slaData[0].genericEnduser == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>

				<div class="dotted-input-container" *ngIf="slaData[0].serviceTypeId == '6'">
					<span>{{ labels.lbl_geral_restrito }}</span>
					<cpi-checkbox
						[value]="slaData[0].restricted ?? 0"
						(oValue)="onRestrictedChange($event)"
						[innerText]="slaData[0].restricted == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>

				<cpi-dot-bounce-loading-effect
					class="mt-2 ml-2"
					*ngIf="isEndusersLoading"
					[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
				<div *ngIf="!isEndusersLoading && slaData[0].restricted == 1" [ngStyle]="{ 'margin-bottom': '20px' }">
					<cpi-generic-form-gen [setGenericForm]="optionsEndusers" [columns]="1" [labels]="labels" [columns]="2">
					</cpi-generic-form-gen>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_tipo_hora }} *</span>
					<cpi-checkbox
						[value]="slaData[0].businessHours ?? 0"
						(oValue)="slaData[0].businessHours = $event"
						[innerText]="slaData[0].businessHours == 1 ? labels.lbl_horario_comercial : labels.lbl_geral_corrida">
					</cpi-checkbox>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_tipo_hora_segundo_prazo }}</span>
					<cpi-checkbox
						[value]="slaData[0].secondSlaBusinessHours ?? 0"
						(oValue)="slaData[0].secondSlaBusinessHours = $event"
						[innerText]="slaData[0].secondSlaBusinessHours == 1 ? labels.lbl_horario_comercial : labels.lbl_geral_corrida">
					</cpi-checkbox>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_quantidade_horas_sla }}</span>
					<input
						mask="099:00"
						[(ngModel)]="slaData[0].sla"
						[placeholder]="convertToHours(slaData[0].sla)"
						name="sla"
						[ngModelOptions]="{ standalone: true }" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_quantidade_horas_sla_vip }}</span>
					<input
						mask="099:00"
						[(ngModel)]="slaData[0].slavip"
						[placeholder]="convertToHours(slaData[0].slavip)"
						name="slavip"
						[ngModelOptions]="{ standalone: true }" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_quantidade_horas_segundo_prazo_sla }}</span>
					<input
						mask="099:00"
						[(ngModel)]="slaData[0].secondSla"
						[placeholder]="convertToHours(slaData[0].secondSla)"
						type="secondSla"
						[ngModelOptions]="{ standalone: true }" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_quantidade_horas_tempo_resposta }}</span>
					<input
						mask="099:00"
						[(ngModel)]="slaData[0].slaResponseTime"
						[placeholder]="convertToHours(slaData[0].slaResponseTime)"
						name="slaResponseTime"
						[ngModelOptions]="{ standalone: true }" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_quantidade_horas_segundo_prazo_sla_vip }}</span>
					<input
						mask="099:00"
						[(ngModel)]="slaData[0].secondSlaVip"
						[placeholder]="convertToHours(slaData[0].secondSlaVip)"
						name="secondSlaVip"
						[ngModelOptions]="{ standalone: true }" />
				</div>

				<div class="dotted-input-container" *ngIf="slaData[0].serviceTypeId == '2'">
					<span>{{ labels.lbl_geral_descricao }}</span>
					<input
						type="text"
						[(ngModel)]="slaData[0].description"
						name="description"
						placeholder="{{ labels.lbl_geral_descricao }}" />
				</div>

				<div class="dotted-input-container" *ngIf="slaData[0].serviceTypeId == '6'">
					<span>{{ labels.lbl_geral_notificacao }}</span>
					<input type="text" [(ngModel)]="slaData[0].notify" name="notify" placeholder="{{ labels.lbl_geral_notificacao }}" />
				</div>
			</form>
		</div>

		<div class="button-container">
			<div class="button" (click)="saveSla()" [ngClass]="{ disabled: !checkRequiredFields(slaData[0]) }">
				{{ labels.lbl_geral_salvar }}
			</div>
			<div class="button" (click)="removeSla()" [ngClass]="{ disabled: !checkRequiredFields(slaData[0]) }">
				{{ labels.lbl_geral_excluir }}
			</div>
		</div>

		<div class="tip">{{ labels.lbl_campos_horas_preenchimento_formato }}</div>
	</div>
</div>

<cpi-dot-bounce-loading-effect class="mt-2 ml-2" *ngIf="isLabelsLoading" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
